import React from "react";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import images from "@/utils/images";

export const ProviderBanner = (props) => {
  const { bodyText, clickUrl, headerText } = props;

  return (
    <DashboardCard2
      className="banner tw:flex-row tw:items-end tw:justify-between tw:overflow-hidden tw:p-0!"
      onClick={() => window.open(clickUrl, "_blank")}
      rawChildren
    >
      <div className="tw:m-6 tw:flex tw:max-w-1/2 tw:flex-col tw:gap-4">
        <div className="fs-18 tw:font-bold">{headerText}</div>
        <div className="fs-1">{bodyText}</div>
      </div>

      <figure className="tw:max-lg:-mr-20">
        <img alt="banner" className="tw:size-full" src={images("./provider/banner.svg")} />
      </figure>
    </DashboardCard2>
  );
};
